import { Component, OnInit, ChangeDetectorRef, AfterViewInit, AfterViewChecked } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TrocarSenhaDialogComponent } from '../usuario/trocar-senha-dialog/trocar-senha-dialog.component';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Misc } from '../util/misc';
import { UtilService } from 'src/app/services/util.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewChecked {

  texto = '';
  localUtilService: UtilService;

  constructor(
    public utilService: UtilService,
    private authenticationService: AuthenticationService,
    private changeDetectRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private toastr: ToastrComponent,
    private misc: Misc
  ) {
    this.localUtilService = utilService;
  }

  userLogged() {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      // authorized so return true
      return true;
    } else {
      this.utilService.logOut();
    }
  }

  userName() {
    const user = JSON.parse(localStorage.getItem('currentUserPricingWeb'));
    return user.userName;
  }

  ngOnInit() {
    this.utilService.currentMessage.subscribe(message => {
      setTimeout(() => {
        this.texto = (message ? message : '');
      });
    }, error => {
      this.misc.processError(error, 'Ocorreu um erro carregando o cabeçalho.');
    });
  }

  ngAfterViewChecked() {
    this.changeDetectRef.detectChanges();
  }

  trocarSenha(event: MouseEvent): void {
    event.preventDefault();

    const dialogRef = this.dialog.open(TrocarSenhaDialogComponent, {
        width: '380px',
        panelClass: 'default-dialog-container'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Senha atualizada com sucesso. Favor logar novamente!');

        this.utilService.logOut();
      }
    });
  }
}
